import { useContext } from "react";
import { MenuCurrencyContext } from "../context/MenuCurrencyContext";

export const useMenuCurrency = () => useContext(MenuCurrencyContext);
